import { render, staticRenderFns } from "./MySeal.vue?vue&type=template&id=5a647457&scoped=true"
import script from "./MySeal.vue?vue&type=script&lang=js"
export * from "./MySeal.vue?vue&type=script&lang=js"
import style0 from "./MySeal.vue?vue&type=style&index=0&id=5a647457&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a647457",
  null
  
)

export default component.exports